<script>
import ToggleCheckbox from './../../common/ToggleCheckbox';
import illustratorApi from './../../../api/illustrator';

export default {
  props: {
    countries: {
      type: Array,
      required: true
    },

    illustrator: {
      type: Object,
      required: false
    },

    defaultCountryId: {
      type: String,
      required: true
    },

    defaultPhoneCode: {
      type: String,
      required: true
    }
  },

  components: {
    ToggleCheckbox
  },

  data() {
    return {
      countryId: this.defaultCountryId,
      phoneCode: (this.defaultPhoneCode ? this.defaultPhoneCode : null),
      sortedCountriesByName: [],
      sortedCountriesByCode: [],
      isShowLocation: this.illustrator ? this.illustrator.is_show_location : false,
      mostPopularCodes: ['US', 'GB']
    };
  },

  mounted() {
    this.sortedCountriesByName = this.prepareSortCountries('name');

    this.sortedCountriesByCode = this.prepareSortCountries('code');

    this.mostPopularCodes.forEach((code) => {
      let selectedCountry = this.countries.filter((country) => {
        return country.code === code;
      })[0];

      this.sortedCountriesByName.unshift(selectedCountry);
      this.sortedCountriesByCode.unshift(selectedCountry);
    });
  },

  watch: {
    isShowLocation() {
      this.setIsShowLocation();
    }
  },

  methods: {
    changeCountry() {
      let selectedCountry = this.sortedCountriesByName.filter((country) => {
        return country.id === this.countryId;
      })[0];

      if (selectedCountry.phone_code) {
        this.phoneCode = selectedCountry.phone_code;
      }
    },

    prepareSortCountries(type) {
      let countries = Vue.util.extend([], this.countries);

      countries = countries.sort(this[type === 'name' ? 'sortCompareCountryName' : 'sortCompareCountryCode']);

      let otherCountry = countries.filter((country) => {
        return country.code === 'Other' || !country.phone_code;
      })[0];

      countries.splice(countries.indexOf(otherCountry), 1);

      countries.push(otherCountry);

      return countries;
    },

    sortCompareCountryName(a, b) {
      if (a.name < b.name) return -1;

      if (a.name > b.name) return 1;

      return 0;
    },

    sortCompareCountryCode(a, b) {
      if (a.code < b.code) return -1;

      if (a.code > b.code) return 1;

      return 0;
    },

    setIsShowLocation() {
      illustratorApi.setIsShowLocation(this.isShowLocation)
        .then(() => {
          toastr.success(`Direct contact details ${this.isShowLocation ? '' : 'no longer'} included within listing`);
        })
        .catch(() => {
          toastr.error('Server error. Please contact with administrator.');
        });
    }
  }
};
</script>

<style lang="scss" scoped>
  .phone-number {
    .select-wrapper {
      width: 25%;
      display: inline-block;
      top: -12px;
    }

    input {
      width: 70%;
      display: inline-block;
    }
  }
</style>
